const API_BASE = (process.env.REACT_APP_BASEURL_STRAPI || "https://localhost:7113").replace(
    /\/+$/,
    "",
  );
  
  function joinUrl(base, path) {
    return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  }
  
  async function apiFetch(path, opts = {}) {
    const url = joinUrl(API_BASE, path);
    const res = await fetch(url, { ...opts });
  
    if (res.status === 204) return null;
  
    const text = await res.text();
    if (!res.ok) throw new Error(`BFF ${res.status}: ${text}`);
    return text ? JSON.parse(text) : null;
  }
  
  export const apiGet = (path) => apiFetch(path);
  export const apiPost = (path, data) =>
    apiFetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  export const apiPut = (path, data) =>
    apiFetch(path, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  export const apiDelete = (path) => apiFetch(path, { method: "DELETE" });